"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f20013 = void 0;
exports.f20013 = {
    "中文": [
        9022,
        9025,
        9027,
        9028,
        9031,
        9037
    ]
};
